import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Drawer, Space, Typography } from 'antd';
import { DragAndDropList } from '@yuhuinc/ui-library';

import { getTranslatedString } from 'helpers/i18n';

const { Title, Text } = Typography;
const StyledDrawer = styled(Drawer)`
  &.ant-drawer-right.ant-drawer-open.no-mask {
    transform: none; // Fix a bug with drag and drop items inside the drawer component.
  }
`;
const StyledSpace = styled(Space)`
  width: 100%;
`;

const titleText = getTranslatedString('landlordPortal.applicationTemplate.prototypesDrawer.title');

const BlockLibraryDrawer = ({ selectedLocale, prototypeList, isOpen, onClose }) => {
  return (
    <StyledDrawer
      title={titleText}
      closable
      mask={false}
      visible={isOpen}
      onClose={onClose}
      width={598}
    >
      {prototypeList.map(
        (category) =>
          category.prototype_blocks.length > 0 && (
            <StyledSpace direction="vertical" key={category.id}>
              <div>
                <Title level={5}>{category[`name_${selectedLocale}`]}</Title>
                <Text>{category[`description_${selectedLocale}`]}</Text>
              </div>

              <DragAndDropList
                items={category.prototype_blocks}
                listId={`${category.id}`}
                renderItemLabel={(prototypeBlock) =>
                  prototypeBlock.translations[selectedLocale]?.title
                }
                hideEdit
                hideDelete
              />
            </StyledSpace>
          )
      )}
    </StyledDrawer>
  );
};

BlockLibraryDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BlockLibraryDrawer;
